"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[302],{

/***/ 26:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Image(props, ref) {
    const { alt , loading , src , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: ref,
        srcSet: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildSrcSet */ .fY)(src),
        src: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)(src.url),
        ...rest,
        alt: alt || "",
        decoding: "async",
        loading: loading || "lazy"
    });
}));


/***/ }),

/***/ 7302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TeamSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(608);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2606);
/* harmony import */ var _components_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26);




function TeamSection(param) {
    let { data: { title , lead , employees  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_1__/* .ContainerSize.wide */ .B.wide,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-12 gap-1.5 md:gap-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-start-2 col-span-11 md:col-start-4 md:col-span-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-bold text-22 leading-135 md:text-25 md:leading-140 text-blue-800 mb-6",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "prose mb-8 md:mb-16",
                            dangerouslySetInnerHTML: {
                                __html: lead
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-12 gap-1.5 md:gap-6 gap-y-12",
                children: employees && employees.map((employee)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-span-12 md:col-span-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full aspect-w-4 aspect-h-3 md:aspect-w-16 md:aspect-h-12 rounded-xl md:rounded-3xl mb-6 bg-[#D9D9D9]",
                                children: employee.portrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute inset-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        className: "h-full w-full object-cover bg-center bg-cover rounded-xl md:rounded-3xl",
                                        src: employee.portrait,
                                        height: employee.portrait.height,
                                        width: employee.portrait.width,
                                        alt: employee.portrait.alternativeText,
                                        sizes: "(max-width: 768px) 100vw,33vw"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid md:block grid-cols-12 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-start-2 col-span-11 md:col-start-1 md:col-span-12",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "text-17 leading-140 tracking-2 font-bold text-blue-800 mb-4",
                                            children: [
                                                employee.titlesSalutation,
                                                " ",
                                                employee.firstName,
                                                " ",
                                                employee.middleName,
                                                " ",
                                                employee.lastName,
                                                " ",
                                                employee.suffix,
                                                employee.linkedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: employee.linkedIn,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "inline ml-2 relative top-[-4px]",
                                                        src: "/linkedIn.svg",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-17 leading-160",
                                            children: employee.description
                                        }),
                                        employee.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "prose bio mt-2 md:mt-4",
                                            dangerouslySetInnerHTML: {
                                                __html: employee.bio
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    }, employee.id))
            })
        ]
    });
}


/***/ })

}]);